import { Component, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-search-input',
  imports: [FormsModule],
  templateUrl: './search-input.html',
  styleUrl: './search-input.css',
})
export class SearchInput {
  placeholder = input('Buscar...');
  instant = input(false);
  value = model('');
  search = output<string>();

  protected onInput(): void {
    if (this.instant()) this.onSearch();
  }

  protected onSearch(): void {
    this.search.emit(this.value().trim());
  }
}
